import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface RenewalGroupHealthPlanInformationDTO {
  id: string
  startDate: string
  endDate: string
  planName: string
  insuranceCarrier: string
  waitingPeriod: number
  useSame?: boolean
}

export interface RenewalGroupHealthPlanInformationFormDTO extends RenewalGroupHealthPlanInformationDTO {
  waitingPeriodInput?: number | undefined
}

export const updateGroupHealthPlanInformation = (payload: RenewalGroupHealthPlanInformationFormDTO): Promise<any> => {
  const data = {
    id: payload.id,
    startDate: payload.startDate,
    planName: payload.planName,
    insuranceCarrier: payload.insuranceCarrier,
    useSame: payload.useSame,
    waitingPeriod: payload.waitingPeriod,
  }

  return adminHttpClient.post('/AdminDashboard/Renewal/GroupHealthPlanInformation', data)
}

export const getGroupHealthPlanDetails = (): Promise<RenewalGroupHealthPlanInformationFormDTO> => {
  return adminHttpClient.get('/AdminDashboard/Renewal/GroupHealthPlanInformation')
}
